export default __webpack_public_path__ + "79870359a6d3a69d9c54a7a43a6998bf.png";